
import { mapState } from 'vuex';
import Gallery from './components/Gallery';

export default {
  i18nComponentKey: 'WidgetProductReviewsGallery.WidgetProductReviewsGalleryPc',
  name: 'WidgetProductReviewsGalleryPc',
  components: { Gallery },
  computed: {
    ...mapState('widget', ['widget'])
  }
};
